import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import _ from "lodash";
import {renderContentProtectionFields} from "../form/FormRenderer";
import "../../styles/form.scss";
import {StyledBlackButton, StyledBlueButton} from "../../styles/BootstrapStyles";

const ContentProtection = ({ show, items, data, fields, onClose, onSave }) => {
  const [showModal, setshowModal] = useState(false);
  const [cpData, setCpData] = useState(data);

  const handleOption = (key, value, sourceKey) => {
    let sourceObject = {};
    for (let cpKey in cpData) {
      if (_.toNumber(cpKey) === sourceKey) {
        sourceObject = cpData[cpKey];
      }
    }
    sourceObject[key] = value;
    setCpData({ ...cpData, [sourceKey]: sourceObject });
  };

  useEffect(() => {
    setshowModal(show);
  }, [show]);

  useEffect(() => {
    setCpData({ ...data });
  }, [data]);

  return (
      <Modal
          className="modal"
          backdrop="static"
          show={showModal}
          size="lg"
          centered
          dialogClassName="modalDialog">
        <Modal.Header className="modalHeader">
          <Modal.Title className="modalHeaderTitle">Content Protection Form</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <Form
              onSubmit={(e) => {
                e.preventDefault();
                onSave(cpData);
              }}>
            {
              _.map(items, (item)=>{
                return(
                    <div key={item.key}>
                      <h3 className="contentProtectionTitle">{_.get(item, ' readonlyMetadata.assetTitle', item.assetName)}</h3>
                      {renderContentProtectionFields(
                          fields,
                          true,
                          handleOption,
                          cpData[item.key],
                          item.key)}

                      <hr />
                    </div>

                )
              })
            }
            <Form.Row
                style={{
                  padding: "30px 15px 30px 15px",
                  justifyContent: "right"
                }}>
              <StyledBlueButton
                  id={"save-cp"}
                  type="submit">
                Save
              </StyledBlueButton>
              <StyledBlackButton
                  id={"cancel-cp"}
                  onClick={(e) => {
                    e.preventDefault();
                    onClose();
                  }}>
                Close
              </StyledBlackButton>
            </Form.Row>
          </Form>
        </Modal.Body>
      </Modal>
  );
};

export default ContentProtection;
